<ng-container *ngIf="model">
  <u-icon class="icon" [model]="{ type: 'img', value: model.icon }" *ngIf="model.icon"></u-icon>
  <h1 class="title">{{ model.title }}</h1>
  <p class="content">{{ model.body }}</p>
  <u-icon id="notification-close" (click)="this.close.emit()" class="close-button" [model]="{ type: 'font', value: 'icon-times' }"></u-icon>
</ng-container>
